import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Logo from "../../assets/images/Logo.png"
const styles = {
  root: {
    width: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#fff',
    color: '#fff',
    fontFamily:"SansX",
    zIndex:1000
  },
  button: {
    color: '#fff',
  },
};

class CustomBottomNavigation extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const {label , route ,route2} = this.props
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <BottomNavigation
        // value={value}
        // onChange={this.handleChange}
        showLabels
        className={classes.root}
      >
        <BottomNavigationAction style={{fontFamily:"SansX !important"}} onClick={() => window.open(route2 ,'_self')} label="آخرین سفر ها" icon={<RestoreIcon />} />
        {/* <BottomNavigationAction  > */}
          <img src={Logo}></img>
        {/* </BottomNavigationAction> */}
        <BottomNavigationAction label={label} onClick={() => window.open(route ,'_self')}  icon={<LocationOnIcon />} />
      </BottomNavigation>
    );
  }
}

CustomBottomNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomBottomNavigation);